module.exports = __webpack_public_path__ + "media/images/wines/tempranillo-roble/bottle-detail-806e9c603e1334bbd1e8140b4131fce1.png";